var classes = {"globalBanner":"ZYZKS","globalBannerSlide":"CMJQ5","globalBannerSlideContent":"tSCCX"};

export { classes as default };
